import theme from '../../theme';

const styles = {
  container: {
    marginBottom: '40px',
    paddingBottom: '24px',
    borderBottom: '1px solid rgba(184, 149, 90, 0.2)',
  },
  title: {
    fontFamily: "'EB Garamond', serif",
    fontWeight: '400',
    fontSize: '28px',
    letterSpacing: '0.02em',
    marginBottom: '8px',
    color: theme.textPrimary,
  },
  description: {
    fontSize: '15px',
    color: theme.textMuted,
    margin: 0,
    maxWidth: '560px',
    lineHeight: 1.6,
  },
};

function PageHeader({ title, description }) {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{title}</h1>
      <p style={styles.description}>{description}</p>
    </div>
  );
}

export default PageHeader;
